import { FC, useContext } from "react";
import { NewVersionContext} from "../../../context/newVersionContext";


const NewVersionModal: FC = (): JSX.Element => {
    const { isVersionModalVisible, changeVersionAlert } = useContext(NewVersionContext)

    return (
        <div
            className={`modal fade ${isVersionModalVisible ? 'show show-modal' : ''}`}
            id="exampleModal"
            tabIndex={-1}
            data-bs-backdrop="true"
            aria-hidden="true"
            onClick={(e) => { e.stopPropagation(); changeVersionAlert(!isVersionModalVisible)}}
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <div className="text-center">
                                    <i className="bi bi-exclamation-circle-fill text-warning fs-1"></i>
                                </div>
                                <h3 className="text-center">Change Alert</h3>
                                <p className="text-center fs-6">
                                    A new version is released. Please click on OK button to get the latest version.
                                </p>
                            </div>
                            <div className="col-12 text-center">
                                <button
                                    type="button"
                                    className="btn btn-primary btn-lg px-5"
                                    data-bs-dismiss="modal"
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewVersionModal
